import { render } from "./Sponsoring.vue?vue&type=template&id=79ab7800"
import script from "./Sponsoring.vue?vue&type=script&lang=js"
export * from "./Sponsoring.vue?vue&type=script&lang=js"

import "./Sponsoring.vue?vue&type=style&index=0&id=79ab7800&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__